import { PropsWithChildren } from 'react';
import styles from './Card.module.scss';

interface CardProps {
    title: string;
    onClick: () => void;
}

const Card = ({ title, children, onClick }: PropsWithChildren<CardProps>) => {
    return (
        <div
            role="button"
            tabIndex={0}
            className={styles['card']}
            onClick={onClick}
            onKeyDown={onClick}
            data-qa="card"
        >
            <div className={styles['card__header']}>
                <span className={styles['card__title']} data-qa="title">
                    {title}
                </span>
            </div>
            <div className={styles['card__content']}>{children}</div>
        </div>
    );
};

export default Card;
